import React, { useState, useEffect } from "react";
import { IonIcon, IonLabel, IonImg, IonModal, IonText, IonInput, isPlatform } from "@ionic/react";
import "../../global.scss";
import * as constants from "../../constants";
import PopUpVehicles from "../OnBoarding/PopUpVehicles";
import { checkMediaQuery } from "../../utils";
interface PageHeaderProps {
  mainHeader: string;
  navigation: any;
  showCart?: any;
  cssClass?: string;
  showCars?: any;
  isWeb?: boolean;
  updatePopOver?: Function;
}

const PageHeading: React.FC<PageHeaderProps> = ({
  mainHeader,
  navigation,
  showCart,
  cssClass = "",
  showCars = true,
  isWeb = false,
  updatePopOver = () => null,
}: PageHeaderProps) => {
  const [showCarVehicles, setCarVehicles] = useState(false);
  const [carReg, setCarReg] = React.useState({
    model: "",
    reg: "",
  });
  React.useEffect(() => {
    if (navigation.onBoarding && navigation.userVehiclesList) {
      const data =
        navigation.userVehiclesList.length &&
        navigation.userVehiclesList.find(
          (ele: any) => ele.did === (navigation.selectedVehicleRef || "").split("/").pop(),
        );
      if (!!data) {
        setCarReg({
          model: data.model,
          reg: data.registrationNumber
            ? data.registrationNumber.slice(data.registrationNumber.length - 4)
            : "",
        });
      }
      setCarVehicles(false);
    }
  }, [navigation.userVehiclesList, navigation.selectedVehicleRef]);
  React.useEffect(() => {
    setCarVehicles(false);
  }, [navigation.selectedVehicleRef]);
  return (
    <div
      className={`page-heading ${cssClass} wholeApp`}
      style={{ paddingTop: isPlatform("android") ? 20 : 0 }}
    >
      <div className="page-header-div">
        <img
          src={checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"}
          // src={"/images/left_arrow_gray.svg"}
          className="back_arrow"
          onClick={() => {
            if (!!navigation.saveBookingDetailsHeaderStatus) {
              navigation.saveBookingDetailsHeaderStatus(false);
            }
            if (isWeb) {
              updatePopOver();
              return;
            }
            navigation.location.pathname === "/portal/service_details"
              ? navigation.history.push("/portal/book_service")
              : navigation.history.location.state === "workshop"
              ? navigation.history.push("/portal/book_service")
              : navigation.history.goBack();
          }}
        />
        <IonLabel className="page-heading-label" color="secondary">
          {mainHeader}
        </IonLabel>
        <div />
      </div>
      {navigation.history.location.pathname !== "/portal/add-new-address" && (
        // <div className="responsive_popup" onClick={() => setCarVehicles(true)}>
        //   <IonImg src="/images/carImg.svg" />
        //   <div className="res_container">
        //     <IonLabel className="carnmodel_text">
        //       {" "}
        //       {`${carReg.model} ${carReg.reg}`}
        //     </IonLabel>
        //   </div>
        // </div>
        <div className="cart_car_container">
          {/* <IonImg src="/images/cart_gray.svg" className="gray_cart_img" /> */}
          {!!showCart && (
            <div
              style={{ position: "relative" }}
              onClick={() => navigation.history.push("/portal/cart")}
            >
              {(navigation.cart_items || []).length > 0 && (
                <div className="cart_items_count">
                  <IonLabel className="notification_count_text">
                    {(navigation.cart_items || []).length}
                  </IonLabel>
                </div>
              )}
              <IonImg src="/images/cart_gray.svg" className="gray_cart_img" />
            </div>
          )}
          {!!showCars && <PopUpVehicles {...navigation} />}
        </div>
      )}
    </div>
  );
};
export default PageHeading;
